const LoadingConstants = {
    SHOW_LOADING: "SHOW_LOADING",
    CLOSE_LOADING: "CLOSE_LOADING",
}

export default LoadingConstants;
